const description = {
    email: 'email',
    phone_number: 'telefone',
    username: 'utilizador',
    reminder: 'Lembrete',
    not_found: '404 Não encontrado',
    agree_with_terms: 'Eu li e concordo com os ',
    agree_with_terms_modal: 'Para prosseguir, por favor, concorde com o <link></link>.',
    terms_of_use: 'Termos de uso',
    sign_in: 'Entrar',
    privacy_policy: 'Política de privacidade',
    create_account: 'Criar uma conta',
    switch_account: 'Mudar de conta',
    or: 'ou',
    and: 'e',
    enter_passcode: 'O código de verificação foi enviado para o seu {{address}} {{target}}',
    passcode_sent: 'O código de verificação foi reenviado',
    resend_after_seconds: 'Ainda não recebeu? Reenviar após <span>{{seconds}}</span> segundos',
    resend_passcode: 'Ainda não recebeu? <a>Reenviar código de verificação</a>',
    create_account_id_exists: 'Uma conta com {{value}} já existe. Continuar a fazer login.',
    link_account_id_exists: 'A conta com {{type}} {{value}} já existe, gostaria de vinculá-la?',
    sign_in_id_does_not_exist: 'Nenhuma conta encontrada para {{value}}. Criar uma nova?',
    sign_in_id_does_not_exist_alert: 'A conta com {{type}} {{value}} não existe.',
    create_account_id_exists_alert: 'A conta com {{type}} {{value}} está vinculada a outra conta. Por favor, tente outro {{type}}.',
    social_identity_exist: 'O {{type}} {{value}} está vinculado a outra conta. Por favor, tente outro {{type}}.',
    bind_account_title: 'Vincular ou criar conta',
    social_create_account: 'Pode criar uma nova conta.',
    social_link_email: 'Pode vincular outro email',
    social_link_phone: 'Pode vincular outro telefone',
    social_link_email_or_phone: 'Pode vincular outro email ou telefone',
    social_bind_with_existing: 'Encontrámos uma conta relacionada que já foi registada, e você pode vinculá-la diretamente.',
    skip_social_linking: 'Pular vinculação à conta existente?',
    reset_password: 'Esqueceu a senha',
    reset_password_description: 'Insira os {{types, list(type: disjunction;)}} associados à sua conta e enviaremos o código de verificação para redefinir sua senha.',
    new_password: 'Nova Senha',
    set_password: 'Definir senha',
    password_changed: 'Senha alterada',
    no_account: 'Ainda não tem conta?',
    have_account: 'Já tem conta?',
    enter_password: 'Digite a senha',
    enter_password_for: 'Faça login com a senha do {{method}} {{value}}',
    enter_username: 'Definir nome de usuário',
    enter_username_description: 'O nome de usuário é uma alternativa para o login. O nome de usuário deve conter apenas letras, números e sublinhados.',
    link_email: 'Vincular email',
    link_phone: 'Vincular telefone',
    link_email_or_phone: 'Vincular email ou telefone',
    link_email_description: 'Para maior segurança, vincule o seu email à conta.',
    link_phone_description: 'Para maior segurança, vincule o seu telefone à conta.',
    link_email_or_phone_description: 'Para maior segurança, vincule o seu email ou telefone à conta.',
    continue_with_more_information: 'Para maior segurança, por favor complete os detalhes da conta abaixo.',
    create_your_account: 'Crie a sua conta',
    sign_in_to_your_account: 'Inicie sessão na sua conta',
    no_region_code_found: 'Não foi possível encontrar o código de região do seu telefone.',
    verify_email: 'Verifique o seu email',
    verify_phone: 'Verifique o seu número de telefone',
    password_requirements: 'Requisitos de senha {{items, list}}.',
    password_requirement: {
        length_one: 'requer um mínimo de {{count}} caracter',
        length_two: 'requer um mínimo de {{count}} caracteres',
        length_few: 'requer um mínimo de {{count}} caracteres',
        length_many: 'requer um mínimo de {{count}} caracteres',
        length_other: 'requer um mínimo de {{count}} caracteres',
        character_types_one: 'deve conter pelo menos {{count}} tipo de letras maiúsculas, letras minúsculas, dígitos e símbolos',
        character_types_two: 'deve conter pelo menos {{count}} tipos de letras maiúsculas, letras minúsculas, dígitos e símbolos',
        character_types_few: 'deve conter pelo menos {{count}} tipos de letras maiúsculas, letras minúsculas, dígitos e símbolos',
        character_types_many: 'deve conter pelo menos {{count}} tipos de letras maiúsculas, letras minúsculas, dígitos e símbolos',
        character_types_other: 'deve conter pelo menos {{count}} tipos de letras maiúsculas, letras minúsculas, dígitos e símbolos',
    },
    use: 'Usar',
    single_sign_on_email_form: 'Insira o endereço de email corporativo',
    single_sign_on_connectors_list: 'A sua empresa ativou o Single Sign-On para a conta de email {{email}}. Pode continuar a iniciar sessão com os seguintes fornecedores de SSO.',
    single_sign_on_enabled: 'Esta conta tem o Single Sign-On ativado.',
    authorize_title: 'Autorizar {{name}}',
    request_permission: '{{name}} está solicitando acesso a:',
    grant_organization_access: 'Conceder acesso à organização:',
    authorize_personal_data_usage: 'Autorizar o uso dos seus dados pessoais:',
    authorize_organization_access: 'Autorizar o acesso à organização específica:',
    user_scopes: 'Dados pessoais do usuário',
    organization_scopes: 'Acesso à organização',
    authorize_agreement: `Ao autorizar o acesso, você concorda com o {{name}}'s <link></link>.`,
    authorize_agreement_with_redirect: `Ao autorizar o acesso, você concorda com o {{name}}'s <link></link>, e será redirecionado para {{uri}}.`,
    not_you: 'Não é você?',
    user_id: 'ID do usuário: {{id}}',
    redirect_to: 'Você será redirecionado para {{name}}.',
    auto_agreement: 'Ao continuar, você concorda com os <link></link>.',
    identifier_sign_in_description: 'Introduza o seu {{types, list(type: disjunction;)}} para iniciar sessão.',
    all_sign_in_options: 'Todas as opções de início de sessão',
    identifier_register_description: 'Introduza o seu {{types, list(type: disjunction;)}} para criar uma nova conta.',
    all_account_creation_options: 'Todas as opções de criação de conta',
    back_to_sign_in: 'Voltar para o login',
    support_email: 'Email de suporte: <link></link>',
    support_website: 'Site de suporte: <link></link>',
    switch_account_title: 'Atualmente, você está conectado como {{account}}',
    switch_account_description: 'Para continuar, você sairá da conta atual e mudará automaticamente para a nova conta.',
    about_yourself: 'Fala-nos sobre ti',
};
export default Object.freeze(description);
